import React from 'react';
import PropTypes from 'prop-types';

import PhotoOrderingOverlay from './PhotoOrderingOverlay';
import withModal from '../../../../../../../../components/global/modal/withModal';

export const ALBUM_SLIDESHOW_DESIGNER_PHOTO_ORDERING_MODAL =
  'modal/ALBUM_SLIDESHOW_DESIGNER_PHOTO_ORDERING';

const propTypes = { onRequestClose: PropTypes.func };

const PhotoSelectionOverlayModal = ({ onRequestClose, ...props }) => {
  return <PhotoOrderingOverlay onClose={onRequestClose} {...props} />;
};

PhotoSelectionOverlayModal.propTypes = propTypes;

export default withModal(PhotoSelectionOverlayModal, {
  name: ALBUM_SLIDESHOW_DESIGNER_PHOTO_ORDERING_MODAL,
  dismissible: false,
  size: 'sm',
  type: 'full',
  hideHeader: true,
  shouldCloseOnOverlayClick: false,
  className: 'slideshow-designer-photo-ordering-modal modal-floating-panel',
});
